import { CALL_STATUS, SET_CALLBACKS_STATUS } from '@instructure/quiz-common';
var callAction = function callAction(callStatus, type) {
  return {
    type: CALL_STATUS,
    payload: {
      call: type,
      status: callStatus
    }
  };
};
export var startCallFor = function startCallFor(type) {
  return callAction('calling', type);
};
export var successCallFor = function successCallFor(type) {
  return callAction('success', type);
};
export var errorCallFor = function errorCallFor(type) {
  return callAction('error', type);
};
export var callbacksCompleteForCall = function callbacksCompleteForCall(type) {
  return {
    type: SET_CALLBACKS_STATUS,
    payload: {
      call: type,
      status: 'complete'
    }
  };
};